/*
** Tooltips
*/
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export function tooltips() {

  if (jQuery('.intext-tooltip').length == 0) {
      return;
  }
  tippy('.intext-tooltip', {
    theme: 'custom',
    arrow: true,
    maxWidth: 385,
    placement: 'auto',
    delay: 5,
    hideOnClick: false,
    onShow(instance) {
      var content = instance.reference.attributes["data-tippy-content"].value;
      instance.setContent(content);

      instance._escHandler = (e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          instance.hide();
        }
      };
      document.addEventListener('keydown', instance._escHandler);
    },
    onHide(instance) {
      document.removeEventListener('keydown', instance._escHandler);
    }
  });

}

export default tooltips;
